enum CreateTypes {
  EXPRESSION = 'expression',
  ATTRIBUTE_VALIDATOR = 'attributeValidator',
  REGEX_REPLACER = 'regexReplacer',
}

export default CreateTypes;
